import { AxiosError } from 'axios'
import i18n from 'i18next'
import { cond, is, isEmpty, map } from 'ramda'
import { toast } from 'react-toastify'

const showErrorsFromArrayOfStrings = (arrayOfStrings: string[]) =>
  arrayOfStrings.map((e: string) => toast.error(e))

export const handleApiErrors = (error: AxiosError) => {
  const { response } = error

  if (response && response.status >= 500) {
    toast.error(i18n.t('Internal server error'))
  }

  if (response && response.status >= 400 && response.status <= 499) {
    cond([
      [
        (data) => is(Array, data) && !isEmpty(data),
        (data) => showErrorsFromArrayOfStrings(data),
      ],
      [
        (data) => is(Object, data) && data.detail,
        (data) => toast.error(data.detail),
      ],
      [
        (data) => is(Object, data),
        (data) =>
          map((errs: string[]) => showErrorsFromArrayOfStrings(errs), data),
      ],
    ])(response.data)
  }
}
